// amelia-easify.js
(() => {
  if (window.ameliaEasifyInputsInitialized) return;
  window.ameliaEasifyInputsInitialized = true;
  const products = new WeakSet();
  let nextId = 0;
  const updateInput = input => {
    const option = input.closest('.po-option-root');
    const wrapper = input.closest('.po-textField-root');
    if (!option || !wrapper) return;
    const label = option.querySelector('.po-label-label');
    if (label && !label.htmlFor) {
      if (!input.id) input.id = `amelia-easify-text-${++nextId}`;
      label.htmlFor = input.id;
    }
    if (wrapper.querySelector('.po-textField-characterCount')) return;
    const limit = input.maxLength;
    if (limit < 1) return;
    let counter = wrapper.querySelector('.amelia-text-counter');
    if (!counter) {
      counter = document.createElement('span');
      counter.className = 'amelia-text-counter';
      counter.id = `amelia-easify-count-${++nextId}`;
      wrapper.append(counter);
    }
    const count = `${input.value.length}/${limit}`;
    if (counter.textContent !== count) counter.textContent = count;
    const describedBy = (input.getAttribute('aria-describedby') || '').split(/\s+/).filter(Boolean);
    if (!describedBy.includes(counter.id)) {
      input.setAttribute('aria-describedby', [...describedBy, counter.id].join(' '));
    }
  };
  const selector = '.easify-product-options .po-textField-input[type="text"]';
  const setup = () => {
    document.querySelectorAll('.amp-product').forEach(product => {
      if (products.has(product)) return;
      products.add(product);
      let pending = false;
      const refresh = () => product.querySelectorAll(selector).forEach(updateInput);
      const observer = new MutationObserver(() => {
        if (pending) return;
        pending = true;
        requestAnimationFrame(() => {
          pending = false;
          refresh();
        });
      });
      observer.observe(product, {childList: true, subtree: true});
      product.addEventListener('input', event => {
        if (event.target.matches(selector)) updateInput(event.target);
      });
      product.addEventListener('change', event => {
        if (event.target.matches(selector)) updateInput(event.target);
      });
      document.addEventListener('shopify:section:unload', event => {
        if (event.target.contains(product)) observer.disconnect();
      });
      refresh();
    });
  };
  setup();
  document.addEventListener('shopify:section:load', setup);
})();

;
// amelia-easify-dropdowns.js
(() => {
  if (window.ameliaEasifyDropdownsInitialized) return;
  window.ameliaEasifyDropdownsInitialized = true;
  const products = new WeakSet();
  const dialogs = new WeakSet();
  const setup = () => {
    document.querySelectorAll('.amp-product').forEach(product => {
      if (products.has(product)) return;
      products.add(product);
      const dialog = document.getElementById(product.dataset.easifyGuideId);
      const refresh = () => {
        product.querySelectorAll('.easify-product-options .po-dropdown-root').forEach(dropdown => {
          const label = dropdown.querySelector('.po-label-label > span:first-child');
          const labelRow = dropdown.querySelector('.po-label-root');
          const isRingSize = product.hasAttribute('data-easify-ring-guide') && /\bsize\b|velikost/i.test(label?.textContent || '');
          if (isRingSize && dialog && labelRow && !labelRow.querySelector('.amelia-size-guide-link')) {
            const button = document.createElement('button');
            button.type = 'button';
            button.className = 'amelia-size-guide-link';
            button.textContent = product.dataset.easifyGuideLabel;
            button.setAttribute('aria-haspopup', 'dialog');
            button.setAttribute('aria-controls', dialog.id);
            labelRow.append(button);
          }
          dropdown.querySelectorAll('.po-select-listItem').forEach(item => {
            const content = item.querySelector('.po-optionItem-optionItem');
            if (!content) return;
            const selected = Array.from(content.children).some(child => child.tagName === 'SPAN' && child.textContent.trim() === '✓');
            item.classList.toggle('amelia-dropdown-selected', selected);
            if (selected) content.dataset.selectedLabel = product.dataset.easifySelectedLabel;
          });
        });
      };
      let pending = false;
      const observer = new MutationObserver(() => {
        if (pending) return;
        pending = true;
        requestAnimationFrame(() => {
          pending = false;
          refresh();
        });
      });
      observer.observe(product, {childList: true, subtree: true});
      product.addEventListener('click', event => {
        if (!event.target.closest('.amelia-size-guide-link') || !dialog || dialog.open) return;
        dialog.showModal();
        dialog.dataset.previousOverflow = document.documentElement.style.overflow;
        document.documentElement.style.overflow = 'hidden';
      });
      if (dialog && !dialogs.has(dialog)) {
        dialogs.add(dialog);
        dialog.querySelector('[data-guide-close]').addEventListener('click', () => dialog.close());
        dialog.addEventListener('click', event => {
          if (event.target !== dialog) return;
          const rect = dialog.getBoundingClientRect();
          if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
        });
        dialog.addEventListener('close', () => {
          document.documentElement.style.overflow = dialog.dataset.previousOverflow || '';
        });
      }
      document.addEventListener('shopify:section:unload', event => {
        if (!event.target.contains(product)) return;
        observer.disconnect();
        if (dialog?.open) dialog.close();
      });
      refresh();
    });
  };
  setup();
  document.addEventListener('shopify:section:load', setup);
})();

;
// amelia-birthstones.js
(() => {
  if (window.ameliaBirthstonesInitialized) return;
  window.ameliaBirthstonesInitialized = true;
  const products = new WeakSet();
  const setup = () => {
    document.querySelectorAll('.amp-product[data-birthstone-dialog]').forEach(product => {
      if (products.has(product)) return;
      const dialog = document.getElementById(product.dataset.birthstoneDialog);
      if (!dialog) return;
      products.add(product);
      const initialized = new Map();
      const grid = dialog.querySelector('[data-birthstone-grid]');
      let activeOptionId;
      let pending = false;
      const getRoots = () => Array.from(product.querySelectorAll('.easify-product-options .po-imageSwatches-root')).filter(root => /birthstone|kámen narození/i.test(root.querySelector('.po-label-label > span:first-child')?.textContent || ''));
      const getChoices = root => Array.from(root.querySelectorAll('.po-imageSwatches-optionItem')).map(item => {
        const image = item.querySelector('img');
        const target = image;
        const label = item.querySelector('.po-optionItemLabel-label')?.textContent.trim() || image?.alt || '';
        const price = item.querySelector('.po-optionItemLabel-price')?.textContent.trim() || '';
        const selected = !!item.querySelector('.po-imageOption-checked');
        const disabled = !!item.querySelector('[aria-disabled="true"], input:disabled, button:disabled') || (target && getComputedStyle(target).pointerEvents === 'none');
        return {image, target, label: [label, price].filter(Boolean).join(' '), selected, disabled};
      }).filter(choice => choice.image && choice.target && choice.label);
      const getId = root => root.closest('.po-option-root')?.dataset.optionId;
      const activeRoot = () => getRoots().find(root => getId(root) === activeOptionId);
      const renderGrid = root => {
        grid.replaceChildren();
        getChoices(root).forEach((choice, index) => {
          const button = document.createElement('button');
          button.type = 'button';
          button.className = 'amelia-birthstone-card';
          button.dataset.birthstoneIndex = index;
          button.disabled = choice.disabled;
          button.setAttribute('aria-pressed', String(choice.selected));
          const image = document.createElement('img');
          image.src = choice.image.currentSrc || choice.image.src;
          image.alt = '';
          image.width = 60;
          image.height = 60;
          const label = document.createElement('span');
          label.textContent = choice.label;
          button.append(image, label);
          grid.append(button);
        });
        dialog.querySelector('[data-birthstone-context]').textContent = getRoots().length > 1 ? root.querySelector('.po-label-label > span:first-child').textContent : '';
      };
      const refresh = () => {
        getRoots().forEach(root => {
          const id = getId(root);
          const choices = getChoices(root);
          if (!id || !choices.length) return;
          if (!initialized.has(id)) {
            initialized.set(id, false);
            requestAnimationFrame(() => requestAnimationFrame(() => {
              const current = getRoots().find(candidate => getId(candidate) === id);
              if (current) getChoices(current).filter(choice => choice.selected).forEach(choice => choice.target.click());
              initialized.set(id, true);
              schedule();
            }));
          }
          const field = root.querySelector('.po-field-root');
          if (!field) return;
          choices[0].target.closest('.po-imageSwatches-optionItem').parentElement.classList.add('amelia-birthstone-native');
          root.classList.add('amelia-birthstone-option');
          let trigger = root.querySelector('.amelia-birthstone-trigger');
          if (!trigger) {
            trigger = document.createElement('button');
            trigger.type = 'button';
            trigger.className = 'amelia-birthstone-trigger';
            trigger.setAttribute('aria-haspopup', 'dialog');
            trigger.setAttribute('aria-controls', dialog.id);
            trigger.dataset.birthstoneOptionId = id;
            field.append(trigger);
          }
          const selected = getChoices(root).filter(choice => choice.selected);
          const text = selected.length ? selected.map(choice => choice.label).join(', ') : product.dataset.birthstonePrompt;
          trigger.setAttribute('aria-label', `${root.querySelector('.po-label-label > span:first-child').textContent}: ${text}`);
          const imageSrc = selected[0]?.image.currentSrc || selected[0]?.image.src || '';
          const signature = text + imageSrc;
          if (trigger.dataset.signature !== signature) {
            trigger.replaceChildren();
            if (imageSrc) {
              const image = document.createElement('img');
              image.src = imageSrc;
              image.alt = '';
              image.width = 28;
              image.height = 28;
              trigger.append(image);
            }
            const label = document.createElement('span');
            label.textContent = text;
            trigger.append(label);
            trigger.dataset.signature = signature;
          }
          trigger.setAttribute('aria-expanded', String(dialog.open && activeOptionId === id));
          trigger.setAttribute('aria-invalid', String(root.dataset.birthstoneTouched === 'true' && !selected.length && !!root.querySelector('.po-field-error')));
          trigger.disabled = !initialized.get(id);
        });
        if (dialog.open && !activeRoot()) dialog.close();
      };
      const schedule = () => {
        if (pending) return;
        pending = true;
        requestAnimationFrame(() => {pending = false; refresh();});
      };
      const observer = new MutationObserver(schedule);
      observer.observe(product, {childList: true, subtree: true});
      product.addEventListener('click', event => {
        const trigger = event.target.closest('.amelia-birthstone-trigger');
        if (!trigger || dialog.open) return;
        activeOptionId = trigger.dataset.birthstoneOptionId;
        const root = activeRoot();
        if (!root) return;
        renderGrid(root);
        dialog.showModal();
        dialog.dataset.previousOverflow = document.documentElement.style.overflow;
        document.documentElement.style.overflow = 'hidden';
        trigger.setAttribute('aria-expanded', 'true');
      });
      grid.addEventListener('click', event => {
        const card = event.target.closest('[data-birthstone-index]');
        if (!card || card.disabled) return;
        const root = activeRoot();
        if (!root) return;
        const choice = getChoices(root)[Number(card.dataset.birthstoneIndex)];
        if (!choice || choice.disabled) return;
        root.dataset.birthstoneTouched = 'true';
        if (!choice.selected) choice.target.click();
        dialog.close();
        schedule();
      });
      dialog.querySelector('[data-birthstone-close]').addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', event => {
        if (event.target !== dialog) return;
        const rect = dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right) dialog.close();
      });
      dialog.addEventListener('close', () => {
        document.documentElement.style.overflow = dialog.dataset.previousOverflow || '';
        schedule();
      });
      const revealErrors = event => {
        if (event.type === 'keydown' && event.key !== 'Enter' && event.key !== ' ') return;
        if (!product.contains(event.target) || !event.target.closest('[data-add-to-cart], button[type="submit"], input[type="submit"]')) return;
        getRoots().forEach(root => {root.dataset.birthstoneTouched = 'true';});
        schedule();
      };
      document.addEventListener('click', revealErrors, true);
      document.addEventListener('pointerdown', revealErrors, true);
      document.addEventListener('keydown', revealErrors, true);
      document.addEventListener('shopify:section:unload', event => {
        if (!event.target.contains(product)) return;
        observer.disconnect();
        document.removeEventListener('click', revealErrors, true);
        document.removeEventListener('pointerdown', revealErrors, true);
        document.removeEventListener('keydown', revealErrors, true);
        if (dialog.open) dialog.close();
      });
      refresh();
    });
  };
  setup();
  document.addEventListener('shopify:section:load', setup);
})();

;
// amelia-product.js
(() => {
  if (window.ameliaProductInitialized) return;
  window.ameliaProductInitialized = true;
  const reduceMotion = () => matchMedia('(prefers-reduced-motion: reduce)').matches;
  document.addEventListener('click', event => {
    const button = event.target.closest?.('.amp-product [data-cart-bar-scroll]');
    if (!button) return;
    const product = button.closest('.amp-product');
    const target = product.querySelector('[data-amp-options-anchor]') || product.querySelector('[data-product-variants]') || product.querySelector('[data-product-form]');
    if (!target) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    const offset = window.innerHeight * 0.3;
    const top = Math.max(0, window.scrollY + target.getBoundingClientRect().top - offset);
    window.scrollTo({top, behavior:reduceMotion() ? 'instant' : 'smooth'});
  }, true);
  const setup = (scope = document) => {
    scope.querySelectorAll('.amp-product').forEach(product => {
      if (product.dataset.ampStickyReady) return;
      const button = product.querySelector('.product__content [data-add-to-cart]');
      if (!button) return;
      product.dataset.ampStickyReady = 'true';
      new IntersectionObserver(entries => {
        product.classList.toggle('amp-native-button-visible', entries[0].isIntersecting);
      }, {threshold:0}).observe(button);
    });
    scope.querySelectorAll('[data-amp-details] details').forEach(details => {
      if (details.dataset.ampReady) return;
      details.dataset.ampReady = 'true';
      const summary = details.querySelector('summary');
      const body = details.querySelector('.amp-details__body');
      let animation;
      let targetOpen = details.open;
      summary.setAttribute('aria-expanded',String(targetOpen));
      summary.addEventListener('click', event => {
        event.preventDefault();
        const start = details.getBoundingClientRect().height;
        targetOpen = !targetOpen;
        animation?.cancel();
        summary.setAttribute('aria-expanded',String(targetOpen));
        details.classList.toggle('amp-expanding',targetOpen);
        if (reduceMotion()) {
          details.open = targetOpen;
          details.style.removeProperty('overflow');
          animation = null;
          return;
        }
        details.open = true;
        const closedHeight = summary.getBoundingClientRect().height + parseFloat(getComputedStyle(details).borderTopWidth) + parseFloat(getComputedStyle(details).borderBottomWidth);
        const end = targetOpen ? closedHeight + body.getBoundingClientRect().height : closedHeight;
        details.style.overflow = 'hidden';
        const currentAnimation = details.animate([{height:start+'px'},{height:end+'px'}],{duration:360,easing:'cubic-bezier(.22,.61,.36,1)',fill:'both'});
        animation = currentAnimation;
        currentAnimation.onfinish = () => {
          details.open = targetOpen;
          currentAnimation.cancel();
          details.style.removeProperty('overflow');
          animation = null;
        };
      });
    });
    scope.querySelectorAll('[data-amp-recommendations]').forEach(section => {
      const bind = () => {
        const track = section.querySelector('[data-amp-track]');
        const prev = section.querySelector('[data-amp-prev]');
        const next = section.querySelector('[data-amp-next]');
        if (!track || track.dataset.ampReady) return;
        track.dataset.ampReady = 'true';
        const update = () => {prev.disabled = track.scrollLeft < 2;next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth-2;};
        [prev,next].forEach((button,i) => button.addEventListener('click',() => track.scrollBy({left:(i ? 1:-1)*track.clientWidth,behavior:reduceMotion()?'auto':'smooth'})));
        track.addEventListener('scroll',update,{passive:true});
        new ResizeObserver(update).observe(track);
        update();
      };
      bind();
      if (section.dataset.ampLoaded) return;
      section.dataset.ampLoaded = 'true';
      fetch(section.dataset.url).then(response => {if (!response.ok) throw new Error('Recommendations unavailable');return response.text();}).then(html => {
        const parsed = new DOMParser().parseFromString(html,'text/html');
        const content = parsed.querySelector('[data-amp-related-content]');
        if (content?.querySelector('.amc-card')) {section.replaceChildren(content);bind();}
      }).catch(() => {});
    });
  };
  setup();
  document.addEventListener('shopify:section:load',event => setup(event.target));
})();

